import { FC, useContext } from 'react';
import {
  Button,
  Checkbox,
  Form,
  FormInstance,
  Input,
  InputNumber,
  Select,
  Space,
  Tooltip,
  Typography,
} from 'antd';
import type {
  ExtractionRangeEnum,
  IFormValue,
  IRule,
  Keyword,
  Order,
} from './type';
import type { ITableTag, ITag } from '@/services/custom/extractConfig';

import { IconFont } from '@/components/IconFont';
import {
  extractionRangeOptions,
  INITIAL_RULE,
  INITIAL_VALUES,
  NEGATIVE,
  ORDER,
  POSITIVE,
  TABLE_MODE_OPTIONS,
  TARGET,
} from './const';
import TableObjectItem from './table-object-item';
import FieldAndRuleItem from './field-and-rule-item';
import { useIsMounted } from '@/hooks/useIsMounted';
import { readonlyContext } from '@/pages/CustomCenter/context';
import PositiveNegativeInput, {
  PositiveNegativeInputValidator,
} from './positive-negative-input';

export interface FormType {
  pages?: string;

  /** 抽取范围 */
  extraction_range: keyof typeof ExtractionRangeEnum;

  /** 表格对象 */
  table_order_type: 'ORDER' | 'KEYWORD';
  /** 表格对象-表格顺序 */
  table_order: {
    direction: 'POSITIVE' | 'NEGATIVE';
    offset: number;
  };
  /** 表格对象-关键词 */
  keywords?: string;

  /** 跨页拼接表格 */
  is_cross_page: boolean;

  rules: IRule[];
}

export const FormItem = Form.Item<FormType>;
const { List: FormList } = Form;

const TableForm: FC<{
  form: FormInstance<IFormValue>;
  initialValues?: Partial<IFormValue>;
}> = (props) => {
  const { form, initialValues = INITIAL_VALUES } = props;
  // context
  const readonly = useContext(readonlyContext);
  // is mounted
  // const isMounted = useIsMounted();
  return (
    <Form
      form={form}
      layout="vertical"
      className="w-full"
      initialValues={initialValues}
      disabled={readonly}
    >
      {/* <Form.Item
        label="hello"
        name={'positive_negative'}
        // rules={[
        //   {
        //     message: '',
        //     validator: PositiveNegativeInputValidator,
        //     warningOnly: true,
        //   },
        // ]}
      >
        <PositiveNegativeInput />
      </Form.Item> */}
      <Form.Item label="抽取范围">
        <section className="flex gap-4 w-full items-center">
          <Form.Item<FormType>
            name="extraction_range"
            className="basis-1/3"
            noStyle
          >
            <Select
              getPopupContainer={(el) => el.parentElement}
              placeholder="请选择抽取范围"
              options={extractionRangeOptions}
            />
          </Form.Item>
          <FormItem noStyle shouldUpdate={() => true}>
            {({ getFieldValue }) => {
              const range = getFieldValue(
                'extraction_range',
              ) as FormType['extraction_range'];

              if (range === TARGET) {
                return (
                  <FormItem
                    className="basis-2/3"
                    name="pages"
                    noStyle
                    rules={[
                      {
                        pattern: /^((\d+)|(\d+);|(\d+)-(\d+);?)+$/,
                        message: '请输入正确的格式如 1;3-5;7',
                        warningOnly: true,
                      },
                    ]}
                  >
                    <Input
                      allowClear
                      placeholder="请输入页号如 1;3-5;7"
                      maxLength={32}
                    />
                  </FormItem>
                );
              }
            }}
          </FormItem>
        </section>
      </Form.Item>

      <FormItem label="表格对象">
        <section className="flex gap-4 w-full">
          {/* 抽取范围 */}
          <FormItem name="table_order_type" className="flex-1 mb-0">
            <Select options={TABLE_MODE_OPTIONS} />
          </FormItem>
          {/* 表格对象 */}
          <TableObjectItem />
        </section>
      </FormItem>
      {/* 跨页拼接表格 */}
      <FormItem name="is_cross_page" valuePropName="checked">
        <Checkbox>
          <span className="flex gap-1 items-center">
            跨页拼接表格
            <Tooltip title="开启后，可支持跨页表格内容抽取">
              <IconFont
                className="text-base hover:text-primary"
                type="icon-bangzhu2"
              />
            </Tooltip>
          </span>
        </Checkbox>
      </FormItem>
      {/* 字段和规则 - 循环组件*/}
      <FieldAndRuleItem
        readonly={readonly}
        // TODO: 封装组件都应该传入 prefix 和 fullPrefix
        // prefix={['rules']}
        // fullPrefix={['rules']}
      />
      {/* <Form.Item noStyle shouldUpdate>
        {(form) => (
          <Typography>
            <pre>{JSON.stringify(form.getFieldsValue(), null, 2)}</pre>
          </Typography>
        )}
      </Form.Item> */}
    </Form>
  );
};

export default TableForm;
